import { useBitumioContext } from "providers/BitumioContext";
import { useEffect } from "react";
import { getRoute } from "utils/routing";
import { Navigate } from "react-router-dom";

export default function SignOutPage() {
  const [{ signOff, signedInUser }] = useBitumioContext();

  useEffect(() => {
    // Before signoff check if there is actually a logged in user
    if (signedInUser) {
      signOff();
    }
  }, [signedInUser]);

  return signedInUser ? (
    <div
      style={{
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
      }}
    >
      Signing you out
    </div>
  ) : (
    <Navigate to={getRoute("signin")} replace={true} />
  );
}
